import React from 'react'
import InfoBanner from '../InfoBanner/InfoBanner';

function AboutUs() {
  return (
    <div style={{margin:'0 auto'}}>
        <InfoBanner></InfoBanner>
    </div>
    
  )
}

export default AboutUs;